import { render, staticRenderFns } from "./CustomerUploadMultiple.vue?vue&type=template&id=33222882"
import script from "./CustomerUploadMultiple.vue?vue&type=script&lang=js"
export * from "./CustomerUploadMultiple.vue?vue&type=script&lang=js"
import style0 from "./CustomerUploadMultiple.vue?vue&type=style&index=0&id=33222882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports